export default "__VITE_ASSET__K7cgp6ez__"